<template>
   <b-row v-if="news.length">
      <b-col v-if="!is_other_news">
        <Breadcrumb :collection="breadcrumbCollection" />
      </b-col>
      <b-col v-if="!is_other_news" cols="12" class="d-flex justify-content-center">
         <img class="advertiser-logo" v-if="advertiser.length" :src="advertiser[0].url" alt="" />
      </b-col>
      <b-col v-if="!is_other_news" cols="12" class="section-title p-3">
        <b-container class="d-flex" align-v="center">
          <img src="@/assets/star.svg" alt="Link" slot="icon" class="card-icon">
          <h5 class="mb-0 pb-0 ml-2">Novidades</h5>
        </b-container>
      </b-col>
      <b-container v-if="is_other_news">
        <h5 class="related-news-title">Outras Novidades</h5>
      </b-container>
      <b-col cols="12">
        <b-container :class="is_other_news ? 'related-news-box' : ''">
          <b-col v-if="!is_other_news" cols="12" class="show-length-news pt-2 pl-0 mb-3">
            <p class="p-0 m-0">Mostrando <strong>{{ news.length }} novidades</strong></p>
          </b-col>

          <b-col :cols="is_other_news ? '4' : '12'"
            v-for="{ idt, title, subtitle, thumb, video, created_at } in getNewsList"
            :key="idt"
            :class="['p-0 news ',
                    { 'mb-5': !is_other_news }]">
            <router-link class="router-link"
              @click.native="track(`clique_noticia_${advertiser[0].code}_${idt}`,'clicou_noticia')"
              :to="{ path: newsUrl + idt , query: queryObject }">
              <article class="d-flex align-items-center news-preview">
                <figure class="m-0">
                 <div class="img-uol d-flex align-items-center justify-content-center" :style="{
                   'background-image':'url('+bgNewsImage(thumb)+')',
                   }">
                   <div v-if="video">
                     <img width="48" src="@/assets/play.svg" alt="">
                   </div>
                 </div>
                </figure>
                <div class="content-news-preview px-3">
                  <h6>{{ title }}</h6>
                  <p v-if="!is_other_news" class="mb-0 text-regular"> {{ subtitle }} </p>
                  <time>
                  <strong> {{ dateFormatter(created_at)}} </strong>
                    &bull;
                    {{ dateTimeAgo(created_at) }}
                    </time>
                </div>
              </article>
            </router-link>
          </b-col>
          <b-col v-if="!is_other_news"  cols="12" class="mb-5 d-flex justify-content-center">
             <button v-show="news.length >= total_per_page && hasMoreNews" ref="btnLoadMore"
               @click="page++,incrementTotalPage(page)" class="ver-mais-button">
                Carregar mais
              </button>
          </b-col>
        </b-container>
      </b-col>

   </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NewsApi from '@/services/news';
import { getStringFromDate, getDateTimeAgo } from '@/utils/dateUtils';
import imgUol from '@/assets/img_uol.png';
import Breadcrumb from '@/components/Breadcrumb';

const clearFormOptions = () => ({
  idtCommEventSourceGroup: null,
  qtd: null,
  hasImages: false,
  firstRow: 0,
  excludedIdtNews: null,
});

export default {
  name: 'NewsList',
  props: {
    is_other_news: Boolean,
    idtAdvertiser: Number,
    news_id: Number,
    advertiserCode: String,
  },
  data() {
    return {
      advertiser: {},
      news: [],
      page: 1,
      hasMoreNews: true,
      total_per_page: 10,
      options: {
        ...clearFormOptions(),
      },
      breadcrumbCollection: [],
    };
  },
  components: {
    Breadcrumb,
  },
  async created() {
    await this.fetchAdvertisers();
    await this.loadAdvertiser();
    await this.loadNews();
    this.setBreadCrumb();
  },
  computed: {
    ...mapGetters(['activeAdvertisers']),
    newsUrl() {
      return this.advertiserCode ? `/campanha/${this.advertiserCode}/novidade/` : `/campanha/${this.advertiser[0].code}/novidade/`;
    },
    queryObject() {
      const qs = window.location.search;
      const queryObject = {};
      qs.substr(1).split('&').forEach((_param) => {
        const param = _param.split('=');
        const key = param.shift();
        const value = param.shift();
        queryObject[key] = value;
      });
      return queryObject;
    },
    getNewsList() {
      return this.news.map(item => ({
        idt: item.idt_aff_campaign_news,
        title: item.title,
        subtitle: item.subtitle,
        thumb: item.thumbnail_image,
        video: item.video_url,
        created_at: item.created_at,
      }));
    },
  },
  methods: {
    ...mapActions(['fetchAdvertisers']),
    async loadAdvertiser() {
      if (this.$route.params.code) {
        this.advertiser = this.activeAdvertisers
          .filter(advertiser => advertiser.code === this.$route.params.code.toString());
      }
    },
    async loadNews() {
      let newsResponse; let
        responseData;
      if (!this.is_other_news) {
        this.options.idtCommEventSourceGroup = this.advertiser[0].id;
        this.options.qtd = this.total_per_page + 1;
        this.options.hasImages = true;
        this.options.excludedIdtNews = 0;
        responseData = await NewsApi
          .getNewsList(this.options);
        newsResponse = responseData.lines;

        if (newsResponse.length < this.options.qtd) {
          this.hasMoreNews = false;
        }

        if (newsResponse.length > this.total_per_page) {
          newsResponse.pop();
        }

        this.news = newsResponse;
      } else {
        this.options.idtCommEventSourceGroup = this.idtAdvertiser;
        this.options.qtd = 3;
        this.options.hasImages = true;
        this.options.excludedIdtNews = this.news_id;
        newsResponse = await NewsApi
          .getNewsList(this.options);
        this.news = newsResponse.lines;
      }
    },
    dateFormatter(value) {
      return getStringFromDate(new Date(value));
    },
    dateTimeAgo(value) {
      return getDateTimeAgo(value);
    },
    bgNewsImage(img) {
      if (img) return img;
      return imgUol;
    },
    async incrementTotalPage(page) {
      this.$refs.btnLoadMore.classList.add('loading-placeholder');
      const range = ((this.total_per_page * page) - this.total_per_page);
      const newsOptions = { ...clearFormOptions() };
      newsOptions.idtCommEventSourceGroup = this.advertiser[0].id;
      newsOptions.qtd = this.total_per_page + 1;
      newsOptions.hasImages = true;
      newsOptions.firstRow = range;
      newsOptions.excludedIdtNews = 0;

      const newsResponse = await NewsApi
        .getNewsList(newsOptions);
      const moreNews = newsResponse.lines;

      if (moreNews.length < newsOptions.qtd) {
        this.hasMoreNews = false;
      }

      if (moreNews.length > this.total_per_page) {
        moreNews.pop();
      }

      this.news.push(...moreNews);

      this.$refs.btnLoadMore.classList.remove('loading-placeholder');
    },
    setBreadCrumb() {
      this.breadcrumbCollection = [
        { name: 'Campanhas', url: '/campanhas' },
        { name: this.advertiser[0].name, url: `/campanha/${this.advertiser[0].code}` },
        { name: 'Novidades', url: `/campanha/${this.$route.params.code}/novidades` },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
   .news-preview{
     font-family: $font-1;
     min-height: 120px;

    .img-uol{
      @include rounded();
      @include border-light();
      width: 164px;
      height: 118px;
      background-size: cover;
      background-position: center;
    }
    .content-news-preview{
      h6{
        line-height: 20px;
        color: $text-dark;
        font-weight: bold;
      }
      p{
        color: $text-dark;
        line-height: 1.125em;
      }
      time{
        color: $text-dark;
        font-size: $font-size-lg-small;
        line-height: 1.25em;
      }
    }
   }
   .section-title{
      color: $text-warning;
      background-color: $bg-light-grey;
   }
   .show-length-news{
        color: $text-dark;
        font-size: $font-size-lg-small;
        line-height: 1.25em;
   }
  .ver-mais-button{
    font-family: $font-1;
    border: 1px solid $denim;
    color: $denim;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 174px;
    height: 50px;
    background: #fff;
    outline: none;
  }
  .ver-mais-button:active::after{
    border: 1px solid $denim;
  }
  .router-link{
    text-decoration: none;
    transition: all 2s linear;
  }
  .news-preview:hover{
    background-color: $bg-light-grey;
  }

  .related-news-title {
    padding-bottom: 20px;
    font-family: $font-1;
    color: $text-warning;
  }

  .related-news-box {
    padding: 0;
    display: flex;

    .content-news-preview {
      display: flex;
      flex-direction: column;
    }
  }

  @media screen and (max-width: $lg){
    .news {
      max-width: 100%;
    }

    .related-news-box {
      flex-direction: column;
    }
  }

  @media screen and (max-width: $sm) {
     .img-uol{
      width: 126px !important ;
      height: 91px !important;
    }
  }

</style>
